import { TableDataCell, TableRow } from '@consigli/facade';
import { Project } from '@consigli/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineTrash } from 'react-icons/hi';

interface ProjectTableRowProps {
  project: Project;
  onDelete: (e: React.MouseEvent) => void;
  onClick: () => void;
  isLastRow?: boolean;
}

const SkillTag: FC<{ skill: string }> = ({ skill }) => {
  const { t } = useTranslation();
  return (
    <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-md mr-2 mb-1">
      {t(`services.${skill}`, skill)}
    </span>
  );
};

export const ProjectTableRow: FC<ProjectTableRowProps> = ({
  project,
  onDelete,
  onClick,
  isLastRow = false,
}) => {
  return (
    <TableRow
      className={`cursor-pointer hover:bg-gray-50 transition-colors duration-150 ${
        isLastRow ? '' : 'border-b border-gray-100'
      }`}
      onClick={onClick}
    >
      <TableDataCell className="pl-6 pr-8 text-sm font-medium text-day-neutral-dark py-2.5">
        {project.name}
      </TableDataCell>
      <TableDataCell className="pr-8 text-sm py-2.5">
        <div className="flex flex-wrap">
          {project.activeServices.map((skill) => (
            <SkillTag key={skill} skill={skill} />
          ))}
        </div>
      </TableDataCell>
      <TableDataCell className="pr-8 text-sm text-day-neutral-subtle py-2.5">
        {new Date(project.createdAt).toLocaleDateString(undefined)}
      </TableDataCell>
      <TableDataCell className="pr-8 text-sm text-day-neutral-subtle py-2.5">
        {project.lastUploadedPackage
          ? new Date(project.lastUploadedPackage).toLocaleDateString(undefined)
          : '-'}
      </TableDataCell>
      <TableDataCell className="pr-6 text-sm py-2.5">
        <button
          className="p-2 text-day-neutral-dark hover:bg-gray-200 focus:bg-gray-100 cursor-pointer rounded-md transition-colors duration-150"
          onClick={onDelete}
        >
          <HiOutlineTrash size={20} />
        </button>
      </TableDataCell>
    </TableRow>
  );
};
